import { InspireReport } from 'Shared/types/InspireReport.types';
import PiInstance from './Pi.instance';

export const fetchRelationship = ({
  companyGuid,
  person1,
  person2,
}: {
  companyGuid: string;
  person1: string;
  person2: string;
}) =>
  PiInstance.instance.get(
    `/perform/api/v5/companies/${companyGuid}/relationship/${person1}/${person2}?relationshipType=communication`
  );

export const fetchReport = ({
  companyGuid,
  surveyuserGuid,
  reportType,
}: {
  companyGuid: string;
  surveyuserGuid: string;
  reportType: InspireReport;
}) =>
  PiInstance.instance.get(
    `/inspire/api/v5-inspire/companies/${companyGuid}/person/${surveyuserGuid}/bulkreport?reports=${reportType}&includeFolderCriteria=false`,
    {
      responseType: 'blob',
    }
  );
